export enum LoginMethodType {
  Email = 'email',
  Lichess = 'lichess',
  Google = 'google',
  Apple = 'apple',
}
